module.exports = __webpack_public_path__ + "static/st2-2-4aea8a6782c04943be6b1fc45e8f64f5.jpg";